'use client'

// Street lights — one InstancedMesh per submesh (pole / arm / lamp) across all
// STREET_LIGHTS placements. Previously each light drew its 3 meshes
// individually (18 lights = 54 draws, each also a shadow caster); this is 3.

import { useEffect, useRef } from 'react'
import { useModel } from '../hooks/useModel'
import * as THREE from 'three/webgpu'
import { useNodeMaterials } from '../hooks/useNodeMaterials'
import { STREET_LIGHTS } from '../../../lib/world/sceneConfig'

const PARTS = ['Cylinder114', 'Cylinder114_1', 'Cylinder114_2']

export function StreetLights(props) {
  const { nodes, materials } = useModel('/models/streetLights.glb')
  const { getMat } = useNodeMaterials(materials)

  const poleRef = useRef()
  const armRef = useRef()
  const lampRef = useRef()

  useEffect(() => {
    const dummy = new THREE.Object3D()
    for (const ref of [poleRef, armRef, lampRef]) {
      const im = ref.current
      if (!im) continue
      STREET_LIGHTS.forEach((l, i) => {
        dummy.position.set(l.position[0], l.position[1], l.position[2])
        dummy.rotation.set(l.rotation[0], l.rotation[1], l.rotation[2])
        dummy.updateMatrix()
        im.setMatrixAt(i, dummy.matrix)
      })
      im.instanceMatrix.needsUpdate = true
    }
  }, [nodes])

  const refs = [poleRef, armRef, lampRef]

  return (
    <group {...props} dispose={null}>
      {PARTS.map((part, idx) => {
        const node = nodes[part]
        if (!node) return null
        return (
          <instancedMesh
            key={part}
            ref={refs[idx]}
            args={[node.geometry, getMat(node), STREET_LIGHTS.length]}
            castShadow
            receiveShadow
            frustumCulled={false}
          />
        )
      })}
    </group>
  )
}
